export default __webpack_public_path__ + "static/media/ic_no_image.18a602fc.svg";